import {useAuthUserStore} from "@/stores/auth";

export default {
    index(academyUuid) {
        return useAuthUserStore().getApiClient.get('/subscriptions', {
            params: {
                academy_uuid: academyUuid
            }
        })
    }
}